import React, { useState } from "react";
import { IInspectionResponseModel } from "../../../typings/models/InspectionResponseModel";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { updateInspectionStatus } from "../../../api/apimethods";

interface GridRowProps {
  data: IInspectionResponseModel;
}

const InspectionGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const handleAmendClick = async (id: string, caseNo: string) => {
    if (window.confirm("Are you sure you want to withdraw the inspection?")) {
      var response = null;
      response = await updateInspectionStatus(
        id,
        4 // withdraw
      );
      if (response.data) {
        // window.alert("Inspection case - " + caseId + " has been withdrwan.");
        let inspectionNumber = caseNo;
        let path = `/app-inspection-complete`;
        navigate(path, {
          state: { inspectionNumber: inspectionNumber, type: "dashboard" },
        });
      } else {
        // API call failed
        const errorMessage = "An error occurred. Please try again.";
        setErrorMessage(errorMessage); // Set the error message in state
      }
    }
  };

  return (
    <tr>
      <td>{data.inspectionCaseNumber}</td>
      {/* <td>{data.salutation}</td> */}
      <td>{data.name}</td>
      <td>{data.uen}</td>
      <td>{data.companyName}</td>
      {/* <td>{data.organisationalAddress}</td> */}
      <td>{data.mobileNo}</td>
      <td>{data.contactEmailofAuthorizedPerson}</td>
      <td>{data.inspectionLocation}</td>
      <td>
        {data.inspectionDate}
        {/* {data.insAppHarvestDate &&
          moment.utc(data.insAppHarvestDate).format("DD/MM/YYYY HH:mm a")} */}
      </td>
      {/* <td>{data.insAppModeofContact}</td> */}
      <td>
        {data.inspectionStatus === 1 && (
          <a
            href="#"
            onClick={() =>
              handleAmendClick(data.inspectionCaseId, data.inspectionCaseNumber)
            }
            className="btn btn-success d-block mt-4"
          >
            Withdraw
          </a>
        )}
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default InspectionGridRow;
